import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuItemActionImportationClass } from '../../../../../core/services/menu/menu-item-action-importation.service';
import { IStateParamsService, IStateService } from 'angular-ui-router';

interface IPageMr1004 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrenceEVDOptions: IMultiOccurrenceOptions;
    multiOccurrencePIJOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}


/* @ngInject */
export default function Mr1004Controller(Formulaire: IFormulaireClass,
    $stateParams: IStateParamsService,
    Menu: IMenuClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemActionImportation: IMenuItemActionImportationClass,
    $state: IStateService,
    FormulaireItem: IFormulaireItemClass) {
    const vm: IPageMr1004 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    const formulaireConfirmation = new Formulaire([
        new FormulaireItem('usrnom', {
            default: vm.valeursEcran.usrnom,
            readonly: true,
            hidden: true
        }),
        new FormulaireItem('dattcre', {
            default: nowYmdHms,
            required: true,
            readonly: true,
            hidden: true
        }),
        new FormulaireItem('pjbdsc', {
            largeur: 100
        }),
        new FormulaireItem('tpicleint', {
            largeur: 100
        }),
        new FormulaireItem('evrcleint', {
            default: () => getDataEvrcleint(),
            hidden: true
        }),
        new FormulaireItem('pjbext', {
            hidden: false, //hidden: true ne fonctionne pas
            cssFormulaire: 'd-none pjbtextref-input'
        }),
    ]);

    vm.multiOccurrencePIJOptions = {
        bloc: 'pij',
        actionsNouveaux: new Menu([
            new MenuItemActionImportation(
                'LBL_AJOUT_PIJ',
                'BOUPJB',
                () => ({}),
                {
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_AJOUT_PIJ',
                        formulaire: formulaireConfirmation,
                    },
                    typesFichiers: ['.pdf', '.doc', '.docx', '.png', '.gif', '.jpg', '.jpeg'],
                    successAction: () => $state.reload(),
                    icon: 'add_circle'
                }
            )
        ]),
        fonctions: {
            suiviModification: false
        },
        colonnesVisibles: [
            { nom: 'usrnom', largeur: 126 },
            { nom: 'datcre', largeur: 126 },
            { nom: 'pjbdsc', largeur: 126 },
            { nom: 'tpicod', largeur: 126 },
            { nom: 'tpidsc', largeur: 216 }
        ],
        colonnesCachees: [
            'pjbcleint',
            'pjbext',
            'evdcleint'
        ],
        fileDownloadPreview: {
            isRowWithBtnFunction: (rowData: any): boolean => rowData['pjbcleint'],
            col: {
                nom: 'Fichier',
                largeur: 120,
            },
            download: {
                hidden: () => false
            },
            preview: {
                hidden: (rowData: any): boolean => {
                    const allowedExtensions = ['PDF', 'JPEG', 'JPG', 'PNG'];
                    return !allowedExtensions.includes((rowData['pjbext'] || '').toUpperCase())
                }
            },
            url: {
                nomFonctionDownload: 'BOUPDF',
                nomFonctionPreview: 'BOUPDF',
                srccodBloc: 'mr1004-evd-pij',
                getCleFunction: (rowData: any): string => 
                    `${getDataEvrcleint()},${rowData['evdcleint']},${rowData['pjbcleint']}`
            }
        }
    };

    vm.multiOccurrenceEVDOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        bloc: 'evd',
        colonnesVisibles: [
            { nom: 'vaeevdtypdes_dsc', largeur: 135 },
            { nom: 'evdadrcou', largeur: 135 },
            { nom: 'evdflgdespri', largeur: 95 }
        ],
        multiOccurrenceOptionsEnfant: vm.multiOccurrencePIJOptions
    };


    vm.multiOccurrenceOptions = {
        filtresParametres: [
            { colonne: 'evrcleintref', valeur: $stateParams.evrcleintref, visible: false },
            { colonne: 'stamnetab', valeur: $stateParams.stamnetab, visible: false },
            { colonne: 'caenumdoc', affichage: true },
            { colonne: 'caenummat', affichage: true },
            { colonne: 'eplnummat', affichage: true },
            { colonne: 'nomprnusu', affichage: true }
        ],
        fonctions: {
            importation: false,
            boutonDupliquer: false,
            nouveau: false,
            edition: false,
            supprime: false,
            suiviModification: false
        },
        colonnesVisibles: [
            { nom: 'vaeevcori_dsc', largeur: 115 },
            { nom: 'datcre', largeur: 110 },
            { nom: 'evctxt', largeur: 310 },
            { nom: 'ctpdscabr', largeur: 110 },
            { nom: 'flgpij', largeur: 110 }
        ],
        colonnesCachees: [
            'evrcleint'
        ],
        multiOccurrenceOptionsEnfant: vm.multiOccurrenceEVDOptions
    };
    function nowYmdHms() {
        const d = new Date();
        const pad = (n: any) => String(n).padStart(2, '0');
        return (
            d.getFullYear() + '-' +
            pad(d.getMonth() + 1) + '-' +
            pad(d.getDate()) + ' ' +
            pad(d.getHours()) + ':' +
            pad(d.getMinutes()) + ':' +
            pad(d.getSeconds())
        );
    }

    //Récupérer la clé de l'occurrence sélectionnée
    function getDataEvrcleint() {
        return vm?.valeursEcran?.evrcleint || vm.multiOccurrence.activeRowCleint;
    }

}


